import { setModalState } from '@carvana/merch-nudge-manager/consumer';
import { useNudgeManager } from '@carvana/merch-nudge-manager/provider';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';
import { isProd } from '~/constants/environment';
import { useTotalMatchedInventory } from '~/context/srp/InventoryContext';
import ModalContext from '~/context/srp/ModalContext';
import { logError } from '~/utilities/loggers';

declare global {
  interface Merch {
    totalMatchedInventory?: number;
  }

  interface Window {
    merch?: Merch;
  }
}

export default function useMerchWindowObject() {
  const { isAnyModalOpen } = useContext(ModalContext);
  const totalMatchedInventory = useTotalMatchedInventory();

  useNudgeManager(
    { storageKey: 'srp-nudges' },
    (nudgeId, result) => {
      datadogRum.addAction('Nudge arrived', { nudgeId, ...result });

      if (!isProd) {
        console.debug('Nudge arrived', { nudgeId, ...result });
      }
    },
    (nudgeId, error) => {
      logError(error, { nudgeId });
    }
  );

  useEffect(() => {
    void setModalState('srp-modal', isAnyModalOpen);
  }, [isAnyModalOpen]);

  useEffect(() => {
    window.merch = { ...window.merch, totalMatchedInventory };
  }, [totalMatchedInventory]);
}
